import { render, staticRenderFns } from "./CategoriesSelectField.vue?vue&type=template&id=16c8bcc8&scoped=true&"
import script from "./CategoriesSelectField.vue?vue&type=script&lang=js&"
export * from "./CategoriesSelectField.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesSelectField.vue?vue&type=style&index=0&id=16c8bcc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8bcc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
